export default [
  {
    path: '/videoLogs',
    name: 'VideoLogs',
    component: () => import('./VideoLogs.vue'),
    meta: {title: '视频管理'},
  },
]
